import { render, staticRenderFns } from "./edit-bulk-message-filters.vue?vue&type=template&id=5984e5da&scoped=true&"
import script from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984e5da",
  null
  
)

export default component.exports